import styled from 'styled-components';

export const ClearIcon = styled.img`
    width: 8px; 
    margin-right: 8px;
`;
